import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

import "../fonts/fonts.css"
import "./styles.css"

const IndexPage = () => (
  <Layout>
    <Seo title="Urban Wildlife" />
    <div
      style={{
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1>
        URBAN WILDLIFE
      </h1>
      <h2>
        Wild creatures that thrive around densely populated human settlements
      </h2>
      <form action="https://nft.gamestop.com/collection/urbanwildlife">
        <button type="submit" value="Adopt Now">
          Adopt Now
        </button>
      </form>
    </div>
    <StaticImage
      src="../images/lineup.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <div>
      <h1>
        CLASSIFICATION
      </h1>
      <h2>
        Urban Wildlife exist in groups according to their observed similarities
      </h2>
    </div>
    <StaticImage
      src="../images/taxonomy.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <div>
      <h1>
        URBANIZATION
      </h1>
      <h2>
        The proportion of Uban Wildlife living in towns and cities is increasing
      </h2>
    </div>
    <StaticImage
      src="../images/urbanization.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <StaticImage
      src="../images/dinosaur.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <StaticImage
      src="../images/animal.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <StaticImage
      src="../images/crossbred.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <StaticImage
      src="../images/woof.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <div
      style={{
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1>
        ADOPT TODAY
      </h1>
      <h2>
        Meet all of the Urban Wildlife available for adoption through the NFT Marketplace. Learn more about each animal by visiting their profile.
      </h2>
      <form action="https://nft.gamestop.com/collection/urbanwildlife">
        <button type="submit" value="Adopt Now">
          Adopt Now
        </button>
      </form>
    </div>
    <StaticImage
      src="../images/adoption.png"
      quality={100}
      formats={["auto", "webp", "avif"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <div class="spacer" />
    <div
      style={{
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1>
        LICENSED BREEDERS
      </h1>
      <h2>
        Being a good breeder means finding responsible owners who truly deserve these wonderful creatures. Please take good care of them!
      </h2>
    </div>
    <a href="https://babbling.fish" target="_blank" rel="noreferrer noopener">
      <StaticImage
        src="../images/creators.png"
        quality={100}
        formats={["auto", "webp", "avif"]}
        alt="A Gatsby astronaut"
        style={{ marginBottom: `1.45rem` }}
      />
    </a>
  </Layout>
)

export default IndexPage
